import ClearIconML from './ClearIconML';
export default (props) => {
  return <ClearIconML {...props} />;
};
